/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=f69365d8&ts=true"
import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"
/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_56c7d0d1d885c2cba1c2415451171383/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"library/components/VabApp/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f69365d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f69365d8', __exports__)) {
    api.reload('f69365d8', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=f69365d8&ts=true", () => {
    api.rerender('f69365d8', render)
  })

}


export default __exports__